<ds-themed-search [showCharts]="true"></ds-themed-search>
<ds-search-tracker></ds-search-tracker>
